export const RECIPES_TO_SHOW_DELTA = 10;
export const RECIPES_TO_SHOW_INITIAL = 10;
